// extracted by mini-css-extract-plugin
export default {"app":"App_app__QuJ5y","title":"App_title__QVcEz","description":"App_description__hBBgS","fadeIn":"App_fadeIn__x2oik","slideIn":"App_slideIn__rq1nw"};